/** MUI X DataGrid — align surfaces with app palette in light mode */
const dataGrid = {
  styleOverrides: {
    root: ({ theme }: { theme: any }) => ({
      color: theme.palette.text.primary,
      borderColor: theme.palette.divider,
      "--DataGrid-containerBackground": theme.palette.background.paper,
    }),
    columnHeaders: ({ theme }: { theme: any }) => ({
      backgroundColor: theme.palette.grey[50],
      borderColor: theme.palette.divider,
      color: theme.palette.text.primary,
    }),
    columnHeader: ({ theme }: { theme: any }) => ({
      borderColor: theme.palette.divider,
    }),
    cell: ({ theme }: { theme: any }) => ({
      borderColor: theme.palette.divider,
      color: theme.palette.text.primary,
    }),
    footerContainer: ({ theme }: { theme: any }) => ({
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
    }),
    pinnedRows: ({ theme }: { theme: any }) => ({
      backgroundColor: theme.palette.background.paper,
    }),
  },
};

export default dataGrid;
